module.exports = __webpack_public_path__ + "static/img/contract-primary.7db08356.svg";